const dashStyle = (theme) => ({
	border: {
		width: theme.spacing.unit * 10,
		height: theme.spacing.unit,
		backgroundColor: theme.palette.secondary.light,
		borderRadius: theme.spacing.unit * 2,
		marginTop: theme.spacing.unit,
		marginBottom: theme.spacing.unit * 4
	}
});
export default dashStyle;



// WEBPACK FOOTER //
// ./src/styles/dashStyle.js